import { render } from "./HealthProfessionalPollResult.vue?vue&type=template&id=ea3d5e28"
import script from "./HealthProfessionalPollResult.vue?vue&type=script&lang=js"
export * from "./HealthProfessionalPollResult.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__